// extracted by mini-css-extract-plugin
export default {"container":"mix_container_GVepR","content":"mix_content_kEMCb","details":"mix_details_XRb5M","subtitle":"mix_subtitle_MQ27I"};